<template>
  <v-container id="evidence-list">
    <v-row>
      <v-col cols="12" md="12" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row
      v-if="
        filter.municipioTarefa.municipioTarefaId &&
        (isFullAdmin ||
          (config.termRefAddEvidencia && groupsConfig.termRefAddEvidencia))
      "
    >
      <v-col cols="12" sm="8" offset-sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-insert-evidence
              :edit="false"
              :municipioTarefaP="filter"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :filter="filter"
              @onSave="loadEvidences"
              v-if="isFullAdmin"
            >
              <template v-slot:title> Cadastrar Evidência </template>
            </app-modal-insert-evidence>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="evidences"
          item-key="name"
          class="elevation-1"
          :footer-props="{ itemsPerPageText: 'Itens por página' }"
        >
          <template v-slot:footer.page-text="items">
            {{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }}
          </template>
          <template v-slot:item="props">
            <tr>
              <td :title="props.item.nome">
                {{ formatTableValues(props.item.nome) }}
              </td>
              <td :title="props.item.descricao">
                {{ formatTableValues(props.item.descricao) }}
              </td>
              <td :title="props.item.municipioTarefa.nome">
                {{ formatTableValues(props.item.municipioTarefa.nome) }}
              </td>
              <td>
                <v-row>
                  <v-col
                    cols="1"
                    v-if="
                      isFullAdmin ||
                      (config.termRefEditarEvidencia &&
                        groupsConfig.termRefEditarEvidencia)
                    "
                  >
                    <app-modal-insert-evidence
                      :object="props.item"
                      :edit="true"
                      :color="'warning'"
                      :icon="'mdi-pencil'"
                      :filter="filter"
                      @onSave="loadEvidences"
                    >
                      <template v-slot:title> Edição de Evidência </template>
                    </app-modal-insert-evidence>
                  </v-col>

                  <v-col
                    cols="1"
                    class="col-min-width-bigger"
                    v-if="
                      isFullAdmin ||
                      (config.termRefExcluirEvidencia &&
                        groupsConfig.termRefExcluirEvidencia)
                    "
                  >
                    <app-modal-delete-evidence
                      :payload="props.item"
                      @onDeleteEvidence="loadEvidences"
                    >
                      <template v-slot:title> Deletar Evidência </template>
                    </app-modal-delete-evidence>
                  </v-col>
                </v-row>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <div class="progress" v-if="loading">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>

            <div v-else>Nenhuma Evidência retornada</div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertEvidence from "@/modules/evidence/components/city/ModalInsert";
import AppModalDeleteEvidence from "@/modules/evidence/components/city/ModalDelete";
import { mapActions, mapGetters } from "vuex";
import { cityEvidenceAPI } from "@/modules/city";
import { formatTableValues } from "@/modules/city/components/terms-reference/utils";

export default {
  name: "AppEvidenceList",
  props: {
    filter: { type: Object, default: () => ({ municipioTarefa: {} }) },
  },
  components: {
    AppModalInsertEvidence,
    AppModalDeleteEvidence,
  },
  data() {
    return {
      headers: [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descrição",
          value: "descricao",
        },
        {
          text: "Tarefa",
          value: "municipioTarefa.nome",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ],
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Soluções",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Tarefas",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Evidências",
          disabled: true,
          href: "termo-referencia",
        },
      ],
      evidences: [],
      formatTableValues: formatTableValues,
      loading: false,
    };
  },

  mounted() {
    if (this.isAT || this.isGov) {
      this.headers = [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descrição",
          value: "descricao",
        },
        {
          text: "Atividades",
          value: "municipioTarefa.nome",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ];
      this.breadcrumbs = [
        {
          text: "Grupos de Iniciativas",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Iniciativas",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Atividades",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Evidências",
          disabled: true,
          href: "termo-referencia",
        },
      ];
    }
    this.loadEvidences();
  },
  computed: {
    ...mapGetters(["isFullAdmin", "isAT", "isGov", "config", "groupsConfig"]),
  },
  watch: {
    filter: {
      handler(value) {
        this.loadEvidences();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadEvidences() {
      this.loading = true;
      var filtros = {
        grupoSolucaoId:
          this.filter.municipioGrupoSolucao &&
          this.filter.municipioGrupoSolucao.municipioGrupoSolucaoId,
        municipioId: this.$route.params.id,
        solucaoId:
          this.filter.municipioSolucao &&
          this.filter.municipioSolucao.municipioSolucaoId,
        tarefaId:
          this.filter.municipioTarefa &&
          this.filter.municipioTarefa.municipioTarefaId,
      };
      this.evidences = [];
      cityEvidenceAPI
        .listByCity(filtros)
        .then((resp) => {
          this.evidences = resp.data.filter(
            (item) => item.desabilitado === false
          );
          this.loading = false;
        })
        .catch((resp) => {
          this.loading = false;
          this.$notification.error("Erro ao listar evidências");
        });
    },
    reloadEvidences() {
      this.$emit("onDeleteEvidence");
    },
  },
};
</script>
